import { ArticleCtaType } from '@olagg/db-types'
import { FormArticleCtaData } from '@olagg/validation-schemas/articleCta.schemas'

/** El multiselect devuelve {value,label}; el inventario guarda un array plano. */
const toValues = (options: any): string[] | null => {
  if (!options?.length) return null

  return options.map((option: any) => typeof option === 'string' ? option : option.value)
}

const nullify = (value?: string | null) => (value === '' || value === undefined) ? null : value

/**
 * Traduce el formulario a la fila del inventario. Las claves van en camelCase: el
 * backend las underscorea al recibirlas.
 */
export const toArticleCtaPayload = (dataForm: FormArticleCtaData): Partial<ArticleCtaType> => ({
  ...dataForm,
  experimentKey: nullify(dataForm.experimentKey as string | null),
  startsAt: nullify(dataForm.startsAt as string | null),
  endsAt: nullify(dataForm.endsAt as string | null),
  targeting: {
    tags: toValues(dataForm.targeting?.tags),
    lang: toValues(dataForm.targeting?.lang),
    device: toValues(dataForm.targeting?.device),
    loggedIn: dataForm.targeting?.loggedIn ?? null,
  },
} as Partial<ArticleCtaType>)
